var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#020842"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.984 4.704c-.037-.85-.175-1.435-.372-1.941a3.904 3.904 0 0 0-.925-1.419 3.938 3.938 0 0 0-1.416-.922c-.51-.197-1.09-.334-1.94-.372C10.473.01 10.2 0 8.03 0 5.857 0 5.585.01 4.732.047c-.85.037-1.434.175-1.94.372a3.904 3.904 0 0 0-1.42.925A3.94 3.94 0 0 0 .45 2.76C.253 3.27.116 3.85.078 4.7c-.04.857-.05 1.13-.05 3.302s.01 2.444.047 3.297c.037.85.175 1.435.372 1.941.203.538.519 1.019.925 1.42.4.405.885.721 1.416.921.51.197 1.09.335 1.941.372.853.038 1.125.047 3.298.047 2.172 0 2.444-.01 3.297-.047.85-.037 1.435-.175 1.941-.372a4.093 4.093 0 0 0 2.341-2.34c.197-.51.335-1.092.372-1.942.038-.853.047-1.125.047-3.297 0-2.173-.003-2.445-.04-3.298zm-1.44 6.533c-.035.781-.166 1.203-.276 1.484a2.654 2.654 0 0 1-1.519 1.52c-.281.109-.706.24-1.484.274-.844.038-1.097.047-3.232.047-2.135 0-2.391-.01-3.232-.047-.782-.034-1.204-.165-1.485-.275a2.462 2.462 0 0 1-.919-.597 2.488 2.488 0 0 1-.597-.919c-.11-.28-.24-.706-.275-1.484-.037-.844-.047-1.097-.047-3.232 0-2.135.01-2.391.047-3.232.035-.781.166-1.203.275-1.485.128-.347.332-.662.6-.919.26-.265.572-.469.92-.597.28-.109.706-.24 1.484-.275.844-.037 1.097-.047 3.232-.047 2.138 0 2.391.01 3.232.047.781.035 1.203.166 1.484.275.347.128.663.332.92.597.265.26.468.572.596.92.11.28.241.706.275 1.484.038.844.047 1.097.047 3.232 0 2.135-.009 2.385-.046 3.229z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03 3.891a4.111 4.111 0 0 0 0 8.22 4.111 4.111 0 0 0 0-8.22zm0 6.777a2.667 2.667 0 1 1 0-5.333 2.667 2.667 0 0 1 0 5.333zM13.262 3.729a.96.96 0 1 1-1.92 0 .96.96 0 0 1 1.92 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon_instagram.0ad871142ec15b6bb85618a44ae64050.svg";
export { ForwardRef as ReactComponent };